import { Button } from '@elladx/design-system';
import type { KeyboardEvent } from 'react';

export type SettingsSection = 'sender' | 'shipping' | 'notifications';
const TABS: { id: SettingsSection; label: string; short: string }[] = [
  { id: 'sender', label: 'Sender address', short: 'Sender' },
  { id: 'shipping', label: 'Shipping options', short: 'Shipping' },
  { id: 'notifications', label: 'Notifications', short: 'Alerts' },
];

function SettingsTabs({ active, onChange }: { active: SettingsSection; onChange: (section: SettingsSection) => void }) {
  const moveFocus = (event: KeyboardEvent<HTMLDivElement>) => {
    const current = TABS.findIndex(tab => tab.id === active);
    let next: number;
    if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (current + 1) % TABS.length;
    else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (current + TABS.length - 1) % TABS.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = TABS.length - 1;
    else return;
    event.preventDefault();
    onChange(TABS[next].id);
    event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="tab"]')[next]?.focus();
  };
  return <div className="settings-tabs" role="tablist" aria-label="Settings sections" onKeyDown={moveFocus}>
    {TABS.map(tab => <Button key={tab.id} id={`settings-tab-${tab.id}`} type="button" role="tab"
      aria-label={tab.label} aria-selected={active === tab.id} aria-controls="settings-panel"
      tabIndex={active === tab.id ? 0 : -1} onClick={() => onChange(tab.id)}
      variant={active === tab.id ? 'primary' : 'secondary'}>
      <span className="settings-tab-full" aria-hidden="true">{tab.label}</span>
      <span className="settings-tab-short" aria-hidden="true">{tab.short}</span>
    </Button>)}
  </div>;
}
export default SettingsTabs;
